import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../../Firebase';
import "../AssignCapsuleModalContent.css";
import userProfilImage from '../../assets/icon_user_profile.svg';
import AssignDetailsForm from './AssignDetailsForm';


class AssignCapsuleStep2Content extends Component {

    render() {
        return (
            <AssignCapsuleStep2Form {...this.props}/>
        );
    }

}

const style_picture_empty = {
    filter: "brightness(90%)"
}

const INITIAL_STATE = {
    selectedAnswer: '',
    error: null,
};

class AssignCapsuleStep2FormBase extends Component {

    constructor(props) {
        super(props);
        this.state = INITIAL_STATE
    }

    handleChange = event => {
        this.setState({ selectedAnswer: event.target.value })
        this.props.onRadioSelection(event)
    }

    render() {
        const {usersToDisplay, selectedImportance, selectedTime} = this.props;
    
          return (
            <>

                <div className="assign-capsule-container">

                    <div className="modal-assignee-header">
                        <div onClick={this.props.onBack} className="carousel-control-prev-icon assignee-custom"></div>
                        <div className="modal-assignee-title">Propulser la capsule</div>
                    </div>

                    <form onSubmit={this.props.onSubmitFinal}>

                        <div className="modal-assignee-container">

                            <div className="modal-assignee-form-group">



                                <div className="form-group assignee-visualization">
                                    {usersToDisplay.map((user) => <div className="assignee" key={user.id}>
                                        <img
                                            className="picture-assignee"
                                            src={user.data().image_url_profile !== null ? user.data().image_url_profile : userProfilImage}
                                            style={user.data().image_url_profile == null ? style_picture_empty : {}}
                                            alt='assignee'
                                        ></img>
                                        <div>
                                            <div className="assignee-name" key={user.data().firstname} value={user.data().firstname}>{user.data().firstname} {user.data().lastname}</div>
                                            <div className="assignee-position" key={user.data().position} value={user.data().position}>{user.data().position}</div>
                                        </div>
                                    </div>)}
                                </div>
                                <div className="modal-assignee-subtitle">Évaluer la capsule</div>
                            </div>
                        </div>

                        <div className="assignee-line"></div>

                        <div className="modal-assignee-container">

                            <div className="assignee-question-container">
                                <div className="assignee-question">Quelle est l'importance de cette capsule, selon vous ?</div>
                                    
                                    <AssignDetailsForm 
                                    onRadioSelection={this.props.onRadioSelection}
                                    values={['modérée','forte','très forte']}
                                    labels={['Modérée','Forte','Très forte']}
                                    name={"importance"}/>
                            </div>
                        </div>

                        <div className="assignee-line"></div>

                        <div className="modal-assignee-container">

                            <div className="assignee-question-container">
                                <div className="assignee-question">Quel délai de résolution est nécessaire, selon-vous ?</div>

                                <AssignDetailsForm
                                    onRadioSelection={this.props.onRadioSelection}
                                    values={['court terme (~1 mois)', 'moyen terme (~3 mois)', 'long terme (~6 mois)']}
                                    labels={['Court terme','Moyen terme','Long terme']}
                                    name={"time"} />
                                <div className="d-flex justify-content-around">
                                    <div className="assignee-choice-container"> 
                                        <div className="assignee-choice-example">~1 mois</div>
                                    </div>
                                    <div className="assignee-choice-container">
                                        <div className="assignee-choice-example">~3 mois</div>
                                    </div>
                                    <div className="assignee-choice-container">
                                        <div className="assignee-choice-example">~6 mois</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="assignee-line"></div>

                        <button type="submit" disabled={(selectedImportance.length === 0 || selectedTime.length === 0)} className="modal-assignee-button">Envoyer</button>
                    </form>


                </div>
            </>
        );
    }

}

const AssignCapsuleStep2Form = withRouter(withFirebase(AssignCapsuleStep2FormBase));


export default AssignCapsuleStep2Content;
export { AssignCapsuleStep2Form };
